module.exports = __webpack_public_path__ + "img/back-right.c58b73ba.svg";